import { Check } from 'lucide-react';
import { WISETACK_BRAND, WISETACK_WHY_FINANCING_POINTS } from '@/lib/wisetack/brand';

/**
 * The "Why offer financing" upsell box from Wisetack's low-code Card spec:
 * a Faint-Mint panel with Space-navy heading and Mint check bullets. Shared by
 * every pre-enrollment signup surface so the branding stays identical.
 */
export function WisetackWhyFinancingBox({ className }: { className?: string }) {
  return (
    <div
      className={`rounded-md p-3 ${className ?? ''}`}
      style={{ backgroundColor: WISETACK_BRAND.faintMint }}
    >
      <p className="text-sm font-semibold" style={{ color: WISETACK_BRAND.space }}>
        Why offer financing
      </p>
      <ul className="mt-1.5 space-y-1">
        {WISETACK_WHY_FINANCING_POINTS.map((point) => (
          <li
            key={point}
            className="flex items-center gap-2 text-xs"
            style={{ color: WISETACK_BRAND.space }}
          >
            <Check className="size-3.5 shrink-0" style={{ color: WISETACK_BRAND.mint }} />
            <span>{point}</span>
          </li>
        ))}
      </ul>
    </div>
  );
}
